<a
  class="link"
  routerLinkActive="active"
  matTooltipPosition="right"
  [routerLink]="link"
  [routerLinkActiveOptions]="{ exact }"
  [matTooltip]="title"
  [matTooltipDisabled]="(sideMenuService.minimized | async) === false"
  [matTooltipShowDelay]="200">
  <mat-icon>{{ icon }}</mat-icon>
  @if ((sideMenuService.minimized | async) === false) {
    <span>{{ title }}</span>
  }
</a>
